exports.ballArr = str => {
  return str ? str.split(',').map(x => Number(x)) : [];
};
// 总和 总和单双 总和大小
exports.count = arr => {
  return arr.reduce((a, b) => {
    return Number(a) + Number(b);
  }, 0);
};

exports.singleDouble = num => {
  return num % 2 == 0 ? 1 : 0;
};
exports.singleDoubleCnname = x => {
  return {
    0: '单',
    1: '双'
  }[x];
};

exports.smallBig = (num, max) => {
  return num < max / 2 ? 0 : num > max / 2 ? 1 : 2;
};
exports.smallBigCnname = x => {
  return {
    0: '小',
    1: '大'
  }[x];
};

// 龙虎
exports.dragonTiger = (a, b) => {
  if (Number(a) < Number(b)) {
    return 1;
  } else if (Number(a) > Number(b)) {
    return 0;
  } else if (Number(a) == Number(b)) {
    return 2;
  }
};
exports.dragonTigerCnname = x => {
  return {
    0: '虎',
    1: '龙',
    2: '和'
  };
};

// resArr.length = 3 优先级 0杂六、1半顺、2顺子、3对子、4豹子
exports.continuity = resArr => {
  let res;
  let arr = resArr.map(x => Number(x)).sort((a, b) => a - b);
  // 豹子对子
  if (arr[0] == arr[1] || arr[1] == arr[2]) {
    res = arr[0] == arr[1] && arr[1] == arr[2] ? 4 : 3;
  } else if (arr[1] - arr[0] == 1 || arr[2] - arr[1] == 1) {
    // 顺子半顺
    res = arr[1] - arr[0] == 1 && arr[2] - arr[1] == 1 ? 2 : 1;
  } else {
    res = 0;
  }
  return res;
};
// continuity规则
exports.continuityCnname = {
  0: '杂六',
  1: '半顺',
  2: '顺子',
  3: '对子',
  4: '豹子'
};

// 快三
exports.fishCnname = {
  1: '鱼',
  2: '虾',
  3: '葫芦',
  4: '金钱',
  5: '蟹',
  6: '鸡'
};



// WEBPACK FOOTER //
// ./src/helpers/resPatterns.js